// skipcq: JS-W1028, JS-0128
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import PropTypes from 'prop-types';

/**
 * EditBeerStyleDialog presents a form to edit or create a beer style.
 */
function EditBeerStyleDialog({
  open,
  submitting,
  errorMsg,
  beerStyle,
  isCreateMode = false,
  onClose,
  onChange,
  onSave,
  styleTypes = [],
}) {
  if (!beerStyle) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isCreateMode ? 'Create Beer Style' : 'Edit Beer Style'}</DialogTitle>
      <DialogContent>
        {errorMsg && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMsg}
          </Alert>
        )}
        <Stack spacing={2} sx={{
          mt: 1
        }}>
          <TextField
            label="ID"
            value={beerStyle.id || ''}
            disabled
            fullWidth
            helperText={
              isCreateMode
                ? 'The document ID is assigned when the style is saved'
                : 'ID cannot be changed'
            }
          />
          <TextField
            label="Name"
            name="name"
            value={beerStyle.name || ''}
            onChange={onChange}
            required
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              name="type"
              value={beerStyle.type || ''}
              onChange={onChange}
              label="Type"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {styleTypes.map((typeRow) => (
                <MenuItem key={typeRow.id || typeRow.name} value={typeRow.name}>
                  {typeRow.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          disabled={submitting || !beerStyle.name?.trim()}
          variant="contained"
        >
          {submitting
            ? isCreateMode
              ? 'Creating…'
              : 'Saving…'
            : isCreateMode
              ? 'Create'
              : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditBeerStyleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  submitting: PropTypes.bool,
  errorMsg: PropTypes.string,
  beerStyle: PropTypes.object,
  isCreateMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  styleTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
};

export default EditBeerStyleDialog;

